import MainLayout from 'layouts/MainLayout/MainLayout';
import LoaderFile from 'pages/LoaderFile';
import PermissionError from 'pages/PermissionError';
import SpedFilesList from 'pages/SpedFilesList';
import { Route, Routes } from 'react-router-dom';

import ProtectedRoute from 'components/ProtectedRoute/ProtectedRoute';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<MainLayout />}>
        <Route
          index
          element={
            <ProtectedRoute>
              <SpedFilesList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/loader/:processamentoSpedID"
          element={
            <ProtectedRoute>
              <LoaderFile />
            </ProtectedRoute>
          }
        />
        <Route path="/error" element={<PermissionError />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
